import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "projects-panel" }
const _hoisted_2 = {
  key: 0,
  class: "list-view"
}
const _hoisted_3 = {
  key: 0,
  class: "cards-grid"
}
const _hoisted_4 = { class: "card-photo" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 0,
  class: "toolbar"
}
const _hoisted_9 = { class: "cards-grid" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 1,
  class: "card-img-placeholder"
}
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "card-meta" }
const _hoisted_16 = { class: "card-meta" }
const _hoisted_17 = { class: "card-footer" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 1,
  class: "detail-view"
}
const _hoisted_22 = {
  key: 0,
  class: "detail-card"
}
const _hoisted_23 = { class: "detail-photo-wrap" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = {
  key: 1,
  class: "detail-photo detail-photo--empty"
}
const _hoisted_26 = { class: "detail-info" }
const _hoisted_27 = { class: "detail-title" }
const _hoisted_28 = { class: "detail-row" }
const _hoisted_29 = { class: "detail-value" }
const _hoisted_30 = { class: "detail-row" }
const _hoisted_31 = { class: "detail-value" }
const _hoisted_32 = { class: "detail-row" }
const _hoisted_33 = { class: "detail-value" }
const _hoisted_34 = { class: "detail-row" }
const _hoisted_35 = { class: "detail-value" }
const _hoisted_36 = {
  key: 2,
  class: "form-view"
}
const _hoisted_37 = { class: "form-card" }
const _hoisted_38 = { class: "form-title" }
const _hoisted_39 = { class: "form-field" }
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "form-field" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "form-field" }
const _hoisted_44 = { class: "responsible-list" }
const _hoisted_45 = ["value", "onChange"]
const _hoisted_46 = ["value"]
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = {
  key: 0,
  class: "form-error"
}
const _hoisted_49 = { class: "form-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonBlock = _resolveComponent("SkeletonBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.projectMode === 'list')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.showSkeleton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                  return _createElementVNode("div", {
                    key: i,
                    class: "project-card"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_SkeletonBlock, {
                        width: "100%",
                        height: "100%",
                        radius: "0"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_SkeletonBlock, {
                        width: "70%",
                        height: "15px"
                      }),
                      _createVNode(_component_SkeletonBlock, {
                        width: "50%",
                        height: "11px"
                      }),
                      _createVNode(_component_SkeletonBlock, {
                        width: "40%",
                        height: "11px"
                      })
                    ])
                  ])
                }), 64))
              ]))
            : (_ctx.projects.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"empty-icon\" data-v-3dd60874><svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.4\" data-v-3dd60874><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"3\" data-v-3dd60874></rect><path d=\"M3 9h18M9 21V9\" data-v-3dd60874></path></svg></div><p class=\"empty-title\" data-v-3dd60874>Nenhum projeto cadastrado</p><p class=\"empty-sub\" data-v-3dd60874>Crie o primeiro projeto para começar.</p>", 3)),
                  (!_ctx.isAnalyst)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn-new",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit-project', '')))
                      }, " + Novo projeto "))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (!_ctx.isAnalyst)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("button", {
                          class: "btn-new",
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('edit-project', '')))
                        }, "+ Novo projeto")
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (proj) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: proj.id,
                        class: "project-card"
                      }, [
                        _createElementVNode("div", {
                          class: "card-photo",
                          onClick: ($event: any) => (_ctx.$emit('view-project', proj.id))
                        }, [
                          (proj.photoDataUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.$resolveUrl(proj.photoDataUrl),
                                alt: proj.name,
                                class: "card-img"
                              }, null, 8, _hoisted_11))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("svg", {
                                  width: "32",
                                  height: "32",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4"
                                }, [
                                  _createElementVNode("rect", {
                                    x: "3",
                                    y: "3",
                                    width: "18",
                                    height: "18",
                                    rx: "3"
                                  }),
                                  _createElementVNode("path", { d: "M3 9h18M9 21V9" })
                                ], -1)
                              ]))]))
                        ], 8, _hoisted_10),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("h3", {
                            class: "card-title",
                            onClick: ($event: any) => (_ctx.$emit('view-project', proj.id))
                          }, _toDisplayString(proj.name), 9, _hoisted_14),
                          _createElementVNode("div", _hoisted_15, [
                            _cache[16] || (_cache[16] = _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "8",
                                r: "4"
                              }),
                              _createElementVNode("path", { d: "M4 20c0-4 3.6-7 8-7s8 3 8 7" })
                            ], -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatResponsibleNames(proj)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _cache[17] || (_cache[17] = _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("rect", {
                                x: "3",
                                y: "4",
                                width: "18",
                                height: "18",
                                rx: "2"
                              }),
                              _createElementVNode("path", { d: "M16 2v4M8 2v4M3 10h18" })
                            ], -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatReportDate(proj.createdAt.slice(0, 10))), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("button", {
                            class: "card-btn",
                            type: "button",
                            onClick: ($event: any) => (_ctx.$emit('view-project', proj.id))
                          }, [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("circle", {
                                cx: "11",
                                cy: "11",
                                r: "8"
                              }),
                              _createElementVNode("path", { d: "m21 21-4.35-4.35" })
                            ], -1),
                            _createTextVNode(" Visualizar ", -1)
                          ]))], 8, _hoisted_18),
                          (!_ctx.isAnalyst)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  class: "card-btn",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.$emit('edit-project', proj.id))
                                }, [...(_cache[19] || (_cache[19] = [
                                  _createElementVNode("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2"
                                  }, [
                                    _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                                    _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                                  ], -1),
                                  _createTextVNode(" Editar ", -1)
                                ]))], 8, _hoisted_19),
                                _createElementVNode("button", {
                                  class: "card-btn card-btn--danger",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.$emit('delete-project', proj))
                                }, [...(_cache[20] || (_cache[20] = [
                                  _createStaticVNode("<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-3dd60874><polyline points=\"3 6 5 6 21 6\" data-v-3dd60874></polyline><path d=\"M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6\" data-v-3dd60874></path><path d=\"M10 11v6M14 11v6\" data-v-3dd60874></path><path d=\"M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2\" data-v-3dd60874></path></svg> Excluir ", 2)
                                ]))], 8, _hoisted_20)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
        ]))
      : (_ctx.projectMode === 'view')
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "back-btn",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close-project-mode')))
            }, [...(_cache[21] || (_cache[21] = [
              _createElementVNode("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", { d: "M19 12H5M12 5l-7 7 7 7" })
              ], -1),
              _createTextVNode(" Voltar ", -1)
            ]))]),
            (_ctx.selectedProject)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    (_ctx.selectedProject.photoDataUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "detail-photo",
                          src: _ctx.$resolveUrl(_ctx.selectedProject.photoDataUrl),
                          alt: _ctx.selectedProject.name
                        }, null, 8, _hoisted_24))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[22] || (_cache[22] = [
                          _createElementVNode("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "1.2"
                          }, [
                            _createElementVNode("rect", {
                              x: "3",
                              y: "3",
                              width: "18",
                              height: "18",
                              rx: "3"
                            }),
                            _createElementVNode("path", { d: "M3 9h18M9 21V9" })
                          ], -1),
                          _createElementVNode("span", null, "Sem foto", -1)
                        ]))]))
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.selectedProject.name), 1),
                    _createElementVNode("div", _hoisted_28, [
                      _cache[23] || (_cache[23] = _createElementVNode("span", { class: "detail-label" }, "Acesso", -1)),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.selectedProject.accessMode === 'read' ? 'Somente leitura' : 'Edição'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "detail-label" }, "Responsáveis", -1)),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.formatResponsibleNames(_ctx.selectedProject)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "detail-label" }, "Temporários", -1)),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.formatTempResponsibleNames(_ctx.selectedProject)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "detail-label" }, "Criado em", -1)),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.formatReportDate(_ctx.selectedProject.createdAt.slice(0, 10))), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (!_ctx.isAnalyst)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("button", {
                class: "back-btn",
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close-project-mode')))
              }, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", { d: "M19 12H5M12 5l-7 7 7 7" })
                ], -1),
                _createTextVNode(" Voltar ", -1)
              ]))]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("h2", _hoisted_38, _toDisplayString(_ctx.selectedProject ? 'Editar projeto' : 'Novo projeto'), 1),
                _createElementVNode("div", _hoisted_39, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", {
                    class: "form-label",
                    for: "project-name"
                  }, "Nome do projeto", -1)),
                  _createElementVNode("input", {
                    id: "project-name",
                    class: "form-input",
                    value: _ctx.projectForm.name,
                    type: "text",
                    placeholder: "Nome do projeto",
                    onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateField('name', ($event.target as HTMLInputElement).value)))
                  }, null, 40, _hoisted_40)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "form-label" }, "Foto do projeto", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["drop-zone", { 'drop-zone--over': _ctx.isDragOver }]),
                    onDragenter: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.isDragOver = true), ["prevent"])),
                    onDragover: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.isDragOver = true), ["prevent"])),
                    onDragleave: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.isDragOver = false), ["prevent"])),
                    onDrop: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPhotoDrop && _ctx.onPhotoDrop(...args)), ["prevent"])),
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.triggerProjectPhotoInput && _ctx.triggerProjectPhotoInput(...args)))
                  }, [
                    _createElementVNode("input", {
                      ref: "projectPhotoInputRef",
                      id: "project-photo",
                      class: "hidden-input",
                      type: "file",
                      accept: "image/*",
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onProjectPhotoSelected && _ctx.onProjectPhotoSelected(...args)))
                    }, null, 544),
                    (_ctx.projectForm.photoDataUrl)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("img", {
                            class: "drop-preview",
                            src: _ctx.$resolveUrl(_ctx.projectForm.photoDataUrl),
                            alt: "preview"
                          }, null, 8, _hoisted_42),
                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "drop-hint" }, "Clique para trocar a foto", -1))
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _cache[30] || (_cache[30] = _createStaticVNode("<svg width=\"32\" height=\"32\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.4\" class=\"drop-icon\" data-v-3dd60874><path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\" data-v-3dd60874></path><polyline points=\"17 8 12 3 7 8\" data-v-3dd60874></polyline><line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"15\" data-v-3dd60874></line></svg><span class=\"drop-hint\" data-v-3dd60874>Clique ou arraste uma imagem aqui</span>", 2))
                        ], 64))
                  ], 34)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "form-label" }, "Usuários responsáveis", -1)),
                  _createElementVNode("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectForm.responsibleUsernames, (username, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `resp-${index}`,
                        class: "responsible-row"
                      }, [
                        _createElementVNode("select", {
                          class: "form-select",
                          value: username,
                          onChange: ($event: any) => (_ctx.updateResponsible(index, ($event.target as HTMLSelectElement).value))
                        }, [
                          _cache[32] || (_cache[32] = _createElementVNode("option", { value: "" }, "Selecione um usuário", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (acc) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: acc.username,
                              value: acc.username
                            }, _toDisplayString(acc.name) + " (" + _toDisplayString(acc.username) + ") ", 9, _hoisted_46))
                          }), 128))
                        ], 40, _hoisted_45),
                        _createElementVNode("button", {
                          class: "btn-remove",
                          type: "button",
                          disabled: _ctx.projectForm.responsibleUsernames.length <= 1,
                          onClick: ($event: any) => (_ctx.$emit('remove-responsible', index)),
                          title: "Remover"
                        }, [...(_cache[33] || (_cache[33] = [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5"
                          }, [
                            _createElementVNode("line", {
                              x1: "18",
                              y1: "6",
                              x2: "6",
                              y2: "18"
                            }),
                            _createElementVNode("line", {
                              x1: "6",
                              y1: "6",
                              x2: "18",
                              y2: "18"
                            })
                          ], -1)
                        ]))], 8, _hoisted_47)
                      ]))
                    }), 128)),
                    _createElementVNode("button", {
                      class: "btn-add-responsible",
                      type: "button",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('add-responsible')))
                    }, " + Adicionar responsável ")
                  ])
                ]),
                (_ctx.projectError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.projectError), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("button", {
                    class: "btn-save",
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('save-project')))
                  }, "Salvar projeto"),
                  _createElementVNode("button", {
                    class: "btn-cancel",
                    type: "button",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('close-project-mode')))
                  }, "Cancelar")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}